const SEARCH_LIMIT = 3 as const;

export { SEARCH_LIMIT };
